module.exports = __webpack_public_path__ + "img/logo.28e70820.png";